module.exports = __webpack_public_path__ + "img/9788956607580.6bd2fac8.jpg";